<template>
    <div class="item">
        <div class="title">项目信息</div>
        <div class="value">
          <div class="left">
            <p>项目名称</p>
            <p>项目编号</p>
            <p>客户名称</p>
            <p>公司名称</p>
            <p>联系人</p>
            <p>联系电话</p>
            <p>详细地址</p>
            <p>所属区域</p>
            <p>启用状态</p>
          </div>
          <div class="right">
            <p>{{ objData.name }}</p>
            <p>{{ objData.code }}</p>
            <p>{{ objData.clientName }}</p>
            <p>{{ objData.companyName }}</p>
            <p>{{ objData.contact }}</p>
            <p>{{ objData.contactPhone }}</p>
            <p>{{ objData.address }}</p>
            <p>{{ objData.province }}省{{ objData.city }}市{{ objData.area }}区</p>
            <p>{{ objData.status == "1"?"启用":"停用" }}</p>
          </div>
        </div>
    </div>
  </template>
  
  <script>
import { getQX_projectInfo } from '../../api/api';

  export default {
    data () {
      return {
        objData:{},
      }
    },
    created () { 
      this.projectId = JSON.parse(localStorage.getItem("projectId"))
      if(this.projectId ){
          this.getData(this.projectId)
      }
    },
    mounted () { 
      
      let _this = this
      window.addEventListener('setItemEvent', function(e) {
          const newdata = JSON.parse(e.newValue)
          console.log('值改变了',newdata)
          _this.getData(newdata)
      })
     
    },
    beforeDestroy() {
      // 移除绑定的listenResizeFn事件监听
      window.removeEventListener("setItemEvent",this.getData);
    },
    methods: {
      // 获取项目信息
      async getData(projectId){
        let res = await getQX_projectInfo({
          projectId,
        })
        console.log(res,"项目信息");
        if(res.code == 200){
          this.objData = res.data
        }
      }
    }
    
  }
  </script>

  <style lang="scss" scoped>
  .item{
    padding: 16px 6px 6px 6px;
    background-color: rgba(0, 0, 0, 0.5);
    font-family: SourceHanSansSC-regular;
    width: 500px;
    height: 300px;
    overflow-y: auto;
    .title{
        font-size: 20px;
        font-weight: bold;
        line-height: 29px;
        margin-bottom: 12px;
    }
    .value{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            line-height: 35px;
        }
        .right{
            text-align: right;
        }
    }

  }
  
  
  </style>
  